import { render } from "./MessageControl.vue?vue&type=template&id=3f29d021"
import script from "./MessageControl.vue?vue&type=script&lang=js"
export * from "./MessageControl.vue?vue&type=script&lang=js"

import "./MessageControl.vue?vue&type=style&index=0&id=3f29d021&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__